<template>
    <div class="baggage-section">
        <Info
            icon="SmallBag"
            :title="t({ key: 'shared.small_baggage_title' })"
            :description="description">
            <div class="baggage-badge">
                {{ t({ key: 'checkout.included' }) }}
            </div>
        </Info>
    </div>
</template>

<script lang="ts">
    import { computed, defineComponent } from 'vue';
    import { t } from '@shared/helpers/translation';
    import Info from './Shared/Info.vue';

    export default defineComponent({
        name: 'BaggageSmallBag',
        components: { Info },
        methods: { t },
        props: {
            hasInfant: {
                type: Boolean,
                default: false,
            },
        },
        setup(props) {
            const description = computed<string>(() => {
                const text = t({ key: 'shared.small_baggage_description' });
                const disclaimer = props.hasInfant
                    ? t({
                          key: 'shared.small_baggage_disclaimer',
                      })
                    : '';

                return `${text} ${disclaimer}`;
            });

            return {
                description,
            };
        },
    });
</script>

<style lang="scss">
    @forward './BaggageSelectionForm.scss';
</style>
